import { jsonMember, jsonObject } from 'typedjson';
import { PublicOrderPaymentMethodResponse } from './public-order-payment-method.response';
import { PaymentStatus } from '../../../shared/enums/payment-status';

@jsonObject
export class PublicOrderPaymentResponse {
  @jsonMember(String)
  public readonly number!: string;

  @jsonMember(String)
  public readonly status!: PaymentStatus;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(PublicOrderPaymentMethodResponse)
  public readonly method!: PublicOrderPaymentMethodResponse;
}
